<script setup lang="ts">
import IconDown from 'assets/icons/arrow-down.svg';
import IconUp from 'assets/icons/arrow-up.svg';

const { t } = useI18n();

const links = [
  { href: '/fixed-appliances', label: 'Appliances' },
  { href: '/surgical-guides', label: 'Surgical_guides' },
  { href: '/signature-appliances', label: 'Signature_appliances' },
  { href: '/diagnostics', label: 'Diagnostics' },
  { href: '/biomechanical-appliances', label: 'Biomechanical' },
  { href: '/functional-appliances', label: 'Functional' },
  { href: '/aligners', label: 'Aligners' },
  { href: '/custom-aligner-facilitators', label: 'Aligner_facilitator' },
  { href: '/temporary-prosthetics', label: 'Prosthetics' },
];

const isOpen = ref(false);
const toggle = () => {
  isOpen.value = !isOpen.value;
};
const emit = defineEmits(['close']);

const onClick = async (link: string) => {
  isOpen.value = false;
  emit('close');
};
</script>

<template>
  <div
    class="flex scrollbar"
    :class="['max-xl:flex-col max-lg:pb-4 max-xl:items-start max-xl:overflow-y-scroll', 'xl:h-[42px] xl:items-center xl:gap-9 max-xl:gap-8']"
  >
    <DropMenu
      class="max-xl:hidden z-20"
      title="Products"
      :links="links"
      href="/catalog"
    />
    <div class="xl:hidden w-full">
      <ButtonLevel
        class="w-full justify-between"
        type="4"
        :title="t('Products').toUpperCase()"
        @click="toggle"
      >
        <template #append>
          <IconDown
            v-if="!isOpen"
            @click.prevent.stop="toggle"
          />
          <IconUp
            v-else
            @click.prevent.stop="toggle"
          />
        </template>
      </ButtonLevel>
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <div
          v-show="isOpen"
          class="pl-4 flex flex-col gap-4 items-start pt-5"
        >
          <ButtonLevel
            v-for="link in links"
            :key="link.label"
            type="4"
            :title="t(link.label)"
            :href="link.href"
            @click="onClick"
          />
          <div class="bg-gray-300 w-full h-[1px]" />
        </div>
      </transition>
    </div>
    <ButtonLevel
      type="4"
      :title="t('Instructions').toUpperCase()"
      href="/instructions"
      @click="onClick"
    />
    <!--    <ButtonLevel -->
    <!--      type="4" -->
    <!--      :title="t('About_us').toUpperCase()" -->
    <!--      @click="onClick('/about-us')" -->
    <!--    /> -->
    <ButtonLevel
      type="4"
      :title="t('FAQ').toUpperCase()"
      href="/faq"
      @click="onClick"
    />
    <!--    <ButtonLevel -->
    <!--      type="4" -->
    <!--      :title="t('Imprint').toUpperCase()" -->
    <!--      @click="onClick('/imprint')" -->
    <!--    /> -->
  </div>
</template>

<style scoped>

</style>
